import { UserWorkspaceProfile } from "@models/UserWorkspaceProfile"
import { Box, Button, FormControl, InputLabel, OutlinedInput, Stack, TextField, Typography, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { useChangeDisplayName } from "hooks/useChangeDisplayName";
import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import { UserProfileViewContext } from "context/userProfile/UserProfileViewContext";
import { truncateString } from "helpers/stringHelper";
import { CancelButton, SaveButton, ChangeDisplayNameButton } from './DisplayNameSection.styles';

export const DisplayNameSection = (props: { user: UserWorkspaceProfile, isProfileOfLoggedUser: boolean }) => {
    const [changingDisplayName, setChangingDisplayName] = useState(false);
    const [displayName, setDisplayName] = useState(props.user.displayName);
    const { user } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const { changeDisplayName, changeDisplayNamePending } = useChangeDisplayName();
    const { refreshProfile } = useContext(UserProfileViewContext);

    const handleSave = async () => {
        const res = await changeDisplayName(displayName, props.isProfileOfLoggedUser ? undefined : user.id);
        if (res?.success) {
            setChangingDisplayName(false);
            refreshProfile();
        }
    }

    return <Stack width='100%' direction={'row'} display={'flex'}>
        {changingDisplayName
        ? <>
            <Box width='50%'>
                <FormControl variant="outlined">
                    <TextField id="displayName" label={t('general.newDisplayName')} variant="standard" value={truncateString(displayName, 22)} onChange={(e) => setDisplayName(e.target.value)} />
                </FormControl>
            </Box>
            <Box width='50%'>
                <CancelButton variant='outlined' onClick={() => setChangingDisplayName(false)}>{t('profile.cancel')}</CancelButton>
                <SaveButton loading={changeDisplayNamePending} variant='outlined' color='primary' onClick={handleSave}>{t('profile.save')}</SaveButton>
            </Box>
        </>
        : <>
        <Stack width='50%'>
            <Typography variant="caption" color={theme.palette.text.secondary}>{t('profile.displayName')}</Typography>
            <Typography fontWeight={'500'}>{user.displayName}</Typography>
        </Stack>
        <ChangeDisplayNameButton variant='outlined' onClick={() => setChangingDisplayName(true)}>{t('profile.changeDisplayName')}</ChangeDisplayNameButton>                        
        </>}
    </Stack>
}